import axios from 'axios'
import auth from '@/auth'

export default {

  init() {
    console.log('Init API')
    axios.defaults.baseURL = process.env.API_BASE_URL || 'https://api.projectsmaps.com' || 'http://0.0.0.0:5000';
    //axios.defaults.baseURL = 'http://0.0.0.0:5000';
    axios.interceptors.request.use(config => {
      const token = auth.getToken()
      if (token) {
        config.headers.Authorization = `JWT ${token}`;
      } else {
        config.headers.Authorization = `JWT ${auth.getGuestToken()}`;
      }
      return config;
    }, function(err) {
      console.log(err)
    });

    axios.interceptors.response.use((response) => {
      return response
    }, error => {
      if (error.response && error.response.status == 401) {
        var next = window.location.hash.replace('#/', '/');
        if (!next.startsWith('/login') && !window.location.href.startsWith('/#/login')) {
          window.rerouting = true;
          window.location.href = '/#/login?redirect=' + encodeURIComponent(next);
          window.location.reload();
        }
        return
      } else {
        return Promise.reject(error)
      }
    });
  },

  getResourceList(path, params) {
    return axios.get(path, {params});
  },
  getResourceDetails(path, objectId, params) {
    return axios.get(`${path}${objectId}`, {params});
  },
  postResource(path, params) {
    return axios.post(path, params);
  },
  putResource(path, objectId, params) {
    return axios.put(`${path}${objectId}`, params);
  },
  deleteResource(path, objectId) {
    return axios.delete(`${path}${objectId}`);
  },

}
